module.exports = __webpack_public_path__ + "assets/img/pt-2c8e84e8.png";